import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPublicVideo } from "../../features/news/YoutubePostsSlice";
import { PlayCircleIcon, FireIcon } from "@heroicons/react/24/solid";

const YouTubePosts = () => {
  const posts = useSelector((state) => state.youtube?.items || []);
  const dispatch = useDispatch();
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    dispatch(getPublicVideo());
  }, [dispatch]);

  if (posts.length === 0) {
    return <div></div>;
  }

  const videosToShow = showAll ? posts.slice(1) : posts.slice(1, 4);

  return (
    <div className="flex flex-col gap-8 w-full mb-12">
      <div className="flex items-center gap-3">
        <FireIcon className="w-7 h-7 text-red-500" />
        <h1 className="text-3xl font-bold text-gray-900">Video Nổi Bật</h1>
      </div>

      <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-200">
        <iframe
          src={posts[0]?.url.replace("watch?v=", "embed/")}
          title={posts[0]?.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full aspect-video"
        ></iframe>
        <div className="p-4 bg-white">
          <h2 className="text-xl font-semibold text-gray-800 leading-snug">
            {posts[0]?.title}
          </h2>
        </div>
      </div>

      {/* Danh sách video khác */}
      <div className="flex flex-col gap-5">
        <div className="flex items-center justify-between border-b pb-2">
          <h2 className="text-2xl font-bold text-gray-700">Các video khác</h2>
          <button
            onClick={() => setShowAll((prev) => !prev)}
            className="text-lg text-blue-800 hover:text-blue-600 transition duration-200"
          >
            {showAll ? "Thu gọn" : "Xem tất cả"}
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {videosToShow.map((post) => (
            <a
              key={post?.id}
              href={post?.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group rounded-xl overflow-hidden shadow-md bg-white hover:shadow-xl transition duration-300 border border-gray-200"
            >
              <img
                src={`https://img.youtube.com/vi/${extractYouTubeId(post?.url)}/hqdefault.jpg`}
                alt={post?.title}
                className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="p-4 flex items-center justify-between gap-3">
                <h3 className="text-sm font-medium text-gray-800 leading-snug line-clamp-2 flex-1">
                  {post?.title}
                </h3>
                <PlayCircleIcon className="h-5 w-5 text-red-500 flex-shrink-0" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const extractYouTubeId = (url) => {
  const regExp = /(?:v=|\/embed\/|\.be\/)([^&\n?#]+)/;
  const match = url.match(regExp);
  return match ? match[1] : "";
};

export default YouTubePosts;
